import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { UserRole } from '@api/types';
import { LocalStorageService } from '@shared/services/local-storage.service';
import { Observable } from 'rxjs';
import { RoleService } from 'src/app/security/role.service';

@Injectable({
  providedIn: 'root'
})
export class UsersGuard implements CanActivate {
  constructor(private role: RoleService, private localStorage: LocalStorageService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (
      !this.localStorage.userWithToken ||
      !this.localStorage.userWithToken.role ||
      this.localStorage.userWithToken.role !== UserRole.Owner
    ) {
      this.router.navigateByUrl('404');
      return false;
    }
    return true;
  }
}
